import { AuditOutcome } from "@coherehealth/core-platform-api";
import { CaseType, ServiceCase } from "@coherehealth/qm-api";
import { getReviewCaseOutcomeMapping } from "util/TableUtil";

export type FetchContinuationCaseAlertState = {
  message: string;
  startIcon: JSX.Element;
  buttonDisabled: boolean;
  buttonBody: JSX.Element;
  clickEvent?: () => void;
  state: "LOADING" | "FETCHED" | "TIMED_OUT";
};
export type PillDisplayT = {
  caption: string;
  label: string;
  pillType: "info" | "primary" | "success" | "warning" | "error";
};

export type CaseCompletePageT = {
  pillDataDisplay?: PillDisplayT;
  serviceCase?: ServiceCase | null;
  cohereIds?: string[];
};

export const AuditOutcomes: Record<AuditOutcome, string> = {
  PASS: "Passed",
  FAIL: "Failed",
  WITHDRAWN: "Withdrawn",
};

export const reviewPillType = (serviceCase: ServiceCase | null) => {
  if (serviceCase?.outcome?.reviewOutcome === "APPROVED") {
    return "success";
  } else if (serviceCase?.outcome?.reviewOutcome === "WITHDRAWN") {
    return "info";
  } else {
    return "warning";
  }
};

export const auditPillType = (serviceCase: ServiceCase | null) => {
  if (serviceCase?.outcome?.auditOutcome === "PASS") {
    return "success";
  } else if (serviceCase?.outcome?.auditOutcome === "WITHDRAWN") {
    return "info";
  } else {
    return "warning";
  }
};
export const generateReviewPillLabel = (serviceCase: ServiceCase | null) => {
  if (serviceCase?.outcome?.reviewOutcome) {
    let label = getReviewCaseOutcomeMapping(serviceCase.healthPlan)[serviceCase?.outcome?.reviewOutcome];
    if (
      serviceCase?.outcome?.reviewOutcome === "PENDING_EXTERNAL_REVIEW" &&
      serviceCase?.externalSources?.[0]?.source
    ) {
      label += ": " + serviceCase.externalSources[0].source;
    }
    return label;
  } else {
    return "Review Outcome not provided";
  }
};

export const generateAuditPillLabel = (serviceCase: ServiceCase | null) => {
  if (serviceCase?.outcome?.auditOutcome) {
    return AuditOutcomes[serviceCase?.outcome?.auditOutcome];
  } else {
    return "Audit Outcome not provided";
  }
};
export const reviewPillDisplay = (serviceCase: ServiceCase | null): PillDisplayT => {
  return {
    caption: "Review outcome",
    label: generateReviewPillLabel(serviceCase),
    pillType: reviewPillType(serviceCase),
  };
};

export const auditPillDisplay = (serviceCase: ServiceCase | null): PillDisplayT => {
  return {
    caption: "Audit outcome",
    label: generateAuditPillLabel(serviceCase),
    pillType: auditPillType(serviceCase),
  };
};

export const getTitle = (outcome: string) => {
  switch (outcome) {
    case "NEW_SR":
      return "Request submitted!";
    case "FAX_ATTACHED":
      return "Document attached!";
    case "FAX_ATTACHED_TO_RF":
      return "Request Submitted!";
    case "FAXBACK":
      return "Fax notice sent!";
    case "FORWARDED":
      return "Work complete!";
    case "HEALTH_HELP":
      return "Case documented!";
    case "ANOTHER_SYSTEM":
      return "Case documented!";
    case "CLAIM":
      return "Case documented!";
    case "REVIEW_COMPLETE":
      return "Review complete!";
    case "LETTER_QUEUED_FOR_DELIVERY":
      return "Letter queued for delivery";
    case "LETTER_SAVED":
      return "Letter saved";
    case "UNASSIGNED_HOLD_IN_QUEUE":
      return "Letter saved";
    case "OUTREACH_COMPLETE":
      return "Contact documented!";
    case "FAX_AUDIT_REVIEW":
      return "Fax Audit complete!";
    case "NEW_REFERRAL":
      return "Work complete!";
  }
};

export const getCaseCompleteHeader = (
  outcome?: string,
  isClinicalReviewCase?: boolean,
  caseType?: CaseType,
  isFollowUpCaseCompleted?: boolean
) => {
  if (caseType === "FOLLOW_UP" && isFollowUpCaseCompleted) {
    return getTitle("REVIEW_COMPLETE");
  } else if (caseType === "FOLLOW_UP") {
    return "Follow-up complete!";
  } else if (outcome) {
    return getTitle(outcome);
  } else if (isClinicalReviewCase || caseType === "NEW_HIRE_AUDIT_REVIEW") {
    return getTitle("REVIEW_COMPLETE");
  } else if (caseType === "MISSING_INFORMATION") {
    return getTitle("OUTREACH_COMPLETE");
  } else if (caseType === "FAX_AUDIT_REVIEW") {
    return getTitle("FAX_AUDIT_REVIEW");
  } else {
    return "Outcome not provided!";
  }
};
